var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-toolbar',{attrs:{"flat":"","dense":"","dark":"","color":"secondary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('Vorschau')))])],1),_c('v-card-text',[(_vm.isFile)?_c(_vm.file,{tag:"component",attrs:{"src":_vm.value.fileURL}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }